import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)} className="login">
          <div className="login-container">
            <h2 className="mach-title">
              {translate("InitiateSessionWith")}
              <span className="mach-brand">{translate("clientName")}</span>
            </h2>
            <p className="login-description">{translate("ClientAuthentication")}</p>

            <div className="input-group">
              <input
                className="form-control"
                disabled={onLogin}
                onChange={e => setUsername(e.target.value)}
                required={true}
                type="email"
                autoCorrect="off"
                autoCapitalize="none"
                name="login"
                id="login"
                placeholder={translate("PlaceholderUserName")}
              />
            </div>

            <div className="input-group">
              <input
                className="form-control"
                required={true}
                disabled={onLogin}
                onChange={e => setPassword(e.target.value)}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password"
                name="password"
                placeholder={translate("PlaceholderPassword")}
              />
            </div>

            <button type="submit" className="btn-login" disabled={onLogin || !props.turnstileSuccess} >
              {onLogin ? <Progress animated color="light" value={100} /> : translate("ButtonEnter")}
            </button>

            <div className="forgot-password">
              <a href="#">{translate("ForgotPassword")}</a>
            </div>

            <Alert
              color="danger"
              id="error-message"
              isOpen={error.open}
              toggle={() => setError({ open: false })}
              className="mach-alert"
            >
              <i className="fas fa-exclamation-circle mr-2"></i>
              {error.message}
            </Alert>

            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </div>
        </Form>
      </div>

    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
